/* SHAMTAM cookie-consent banner — logic.
   Drives consent through Shopify's Customer Privacy API (no Shopify cookies touched
   directly). Renders ONLY where shouldShowBanner() is true (consent regions) unless
   force-previewed. Granular non-essential toggles default OFF (pre-ticked = invalid
   consent under EU law); "Accept all" is the one-click path for full opt-in.

   Config comes from window.SHAMTAM_COOKIE (set in shamtam-cookie.liquid):
     { i18nUrl, locale, privacyUrl, forcePreview }
   Force preview anywhere with ?cookie_preview=1 or #cookie-preview. */
(function () {
  if (window.__shamtamCookieInit) return;
  window.__shamtamCookieInit = true;

  var CFG = window.SHAMTAM_COOKIE || {};
  // Coordinate with the welcome popup: it waits for this to resolve before showing,
  // so the two never overlap. Resolved = a choice was made OR no banner is needed.
  window.ShamtamConsent = window.ShamtamConsent || { resolved: false };
  function resolveConsent(){
    if (window.ShamtamConsent.resolved) return;
    window.ShamtamConsent.resolved = true;
    try { document.dispatchEvent(new CustomEvent('shamtam:consent-resolved')); } catch (e) {}
  }
  var LOCALE = (CFG.locale || document.documentElement.getAttribute('lang') || 'en').slice(0, 2).toLowerCase();
  var PRIVACY = CFG.privacyUrl || '/policies/privacy-policy';
  var FORCE = !!CFG.forcePreview ||
    /[?&]cookie_preview=1/.test(location.search) || /cookie-preview/.test(location.hash);

  var EN = { kicker:'Your privacy', title:'A gentle note on cookies',
    body:'We use cookies to keep the shop running and to learn what you love, so we can show you more of it. You choose what to allow.',
    accept:'Accept all', decline:'Decline', customise:'Choose what you allow', privacy:'Privacy policy',
    prefsTitle:'Choose your cookies', prefsSub:'Switch on only what feels right. You can change this any time.',
    essential:'Essential', essentialDesc:'Cart, checkout and security. Always on.',
    analytics:'Analytics', analyticsDesc:'Helps us see what’s working and improve.',
    marketing:'Marketing', marketingDesc:'Relevant offers and ads, fewer random ones.',
    preferences:'Preferences', preferencesDesc:'Remembers your language and currency.',
    save:'Save choices', back:'Back', reopen:'Cookie settings' };
  var T = EN;

  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function (c){ return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;' }[c]; }); }

  function loadI18n(done){
    if (!CFG.i18nUrl) return done();
    fetch(CFG.i18nUrl).then(function (r){ return r.json(); })
      .then(function (j){ T = Object.assign({}, EN, (j && (j[LOCALE] || j.en)) || {}); done(); })
      .catch(function (){ done(); });
  }

  /* ---- Customer Privacy API ---- */
  function withAPI(cb){
    if (window.Shopify && window.Shopify.customerPrivacy) return cb(window.Shopify.customerPrivacy);
    if (!(window.Shopify && window.Shopify.loadFeatures)) {
      if (FORCE) return cb(null); // preview without a live storefront
      return; // not on Shopify storefront context
    }
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err){
      if (err) { if (FORCE) cb(null); return; }
      cb(window.Shopify.customerPrivacy);
    });
  }

  /* ---- Own persisted record of the choice ----
     Shopify's shouldShowBanner() was re-prompting on EVERY page (it does not reliably
     persist our setTrackingConsent across navigations / in incognito), so we keep our own
     flag and use it as the gate. We still call setTrackingConsent on every page so Shopify's
     real tracking enforcement matches the stored choice. */
  var STORE_KEY = 'shamtam_cookie_consent_v1';
  function saveChoice(v){ try { localStorage.setItem(STORE_KEY, JSON.stringify({ analytics: !!v.analytics, marketing: !!v.marketing, preferences: !!v.preferences })); } catch (e) {} }
  function loadChoice(){ try { return JSON.parse(localStorage.getItem(STORE_KEY) || 'null'); } catch (e) { return null; } }

  function setConsent(api, v, after){
    saveChoice(v); // record the choice ourselves so the banner never re-nags
    var payload = { analytics: !!v.analytics, marketing: !!v.marketing, preferences: !!v.preferences, sale_of_data: !!v.marketing };
    if (api && typeof api.setTrackingConsent === 'function') {
      try { api.setTrackingConsent(payload, function (){ after && after(); }); return; } catch (e) {}
    }
    after && after(); // preview / no-API
  }

  function currentConsent(api){
    var c = {};
    try { if (api && api.currentVisitorConsent) c = api.currentVisitorConsent() || {}; } catch (e) {}
    return { analytics: c.analytics === 'yes', marketing: c.marketing === 'yes', preferences: c.preferences === 'yes' };
  }

  /* ---- DOM ---- */
  var SEAL = '<span class="ck-seal" aria-hidden="true"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#FAF6EF" stroke-width="1.6" stroke-linecap="round"><path d="M12 21c0-5 0-9 0-13"/><path d="M12 11c-3 0-5-2-5-5 3 0 5 2 5 5z"/><path d="M12 9c3 0 5-2 5-5-3 0-5 2-5 5z"/></svg></span>';

  var root, api;

  function mount(){
    root = document.getElementById('shamtam-cookie');
    if (!root){ root = document.createElement('div'); root.id = 'shamtam-cookie'; document.body.appendChild(root); }
  }

  function bannerView(){
    return '' +
      '<div class="ck-card" role="dialog" aria-modal="false" aria-label="' + esc(T.title) + '">' +
        '<div class="ck-head">' + SEAL +
          '<div><p class="ck-kicker">' + esc(T.kicker) + '</p><h2 class="ck-title">' + esc(T.title) + '</h2></div>' +
        '</div>' +
        '<p class="ck-body">' + esc(T.body) + '</p>' +
        '<div class="ck-actions">' +
          '<button type="button" class="ck-btn ck-ghost" data-act="decline">' + esc(T.decline) + '</button>' +
          '<button type="button" class="ck-btn ck-accept" data-act="accept">' + esc(T.accept) + '</button>' +
        '</div>' +
        '<div class="ck-links">' +
          '<button type="button" class="ck-link" data-act="prefs">' + esc(T.customise) + '</button>' +
          '<a class="ck-link" href="' + esc(PRIVACY) + '">' + esc(T.privacy) + '</a>' +
        '</div>' +
      '</div>';
  }

  function row(key, name, desc, checked, locked){
    var sw = locked
      ? '<span class="ck-sw" role="switch" aria-checked="true" aria-disabled="true" aria-label="' + esc(name) + '"></span>'
      : '<button type="button" class="ck-sw" role="switch" data-toggle="' + key + '" aria-checked="' + (checked ? 'true' : 'false') + '" aria-label="' + esc(name) + '"></button>';
    return '<div class="ck-row' + (key === 'essential' ? ' ck-first' : '') + '">' +
      '<div style="flex:1"><p class="ck-row-name">' + esc(name) + '</p><p class="ck-row-desc">' + esc(desc) + '</p></div>' + sw + '</div>';
  }

  function prefsView(pre){
    return '' +
      '<div class="ck-card" role="dialog" aria-modal="false" aria-label="' + esc(T.prefsTitle) + '">' +
        '<h2 class="ck-prefs-title">' + esc(T.prefsTitle) + '</h2>' +
        '<p class="ck-prefs-sub">' + esc(T.prefsSub) + '</p>' +
        row('essential', T.essential, T.essentialDesc, true, true) +
        row('analytics', T.analytics, T.analyticsDesc, !!pre.analytics, false) +
        row('marketing', T.marketing, T.marketingDesc, !!pre.marketing, false) +
        row('preferences', T.preferences, T.preferencesDesc, !!pre.preferences, false) +
        '<div class="ck-actions" style="margin-top:16px">' +
          '<button type="button" class="ck-btn ck-ghost" data-act="save">' + esc(T.save) + '</button>' +
          '<button type="button" class="ck-btn ck-accept" data-act="accept">' + esc(T.accept) + '</button>' +
        '</div>' +
      '</div>';
  }

  function showBanner(){ mount(); root.hidden = false; root.innerHTML = bannerView(); bind(); focusFirst(); }
  function showPrefs(){ mount(); root.hidden = false; root.innerHTML = prefsView(currentConsent(api)); bind(); focusFirst(); }
  function focusFirst(){ var b = root.querySelector('.ck-card button, .ck-card a'); if (b) try { b.focus({ preventScroll: true }); } catch (e) { b.focus(); } }

  // After a choice the widget disappears COMPLETELY — no lingering pill. Re-consent is
  // available programmatically via window.ShamtamCookieSettings(), or by linking any
  // element with [data-cookie-settings] or href="#cookie-settings" (e.g. a footer link).
  function hide(){ if (!root) return; root.hidden = true; root.innerHTML = ''; }
  function close(){ resolveConsent(); hide(); }

  function bind(){
    root.querySelectorAll('[data-toggle]').forEach(function (sw){
      sw.onclick = function (){ sw.setAttribute('aria-checked', sw.getAttribute('aria-checked') === 'true' ? 'false' : 'true'); };
    });
    root.querySelectorAll('[data-act]').forEach(function (el){
      el.onclick = function (){
        var a = el.getAttribute('data-act');
        if (a === 'accept') setConsent(api, { analytics: true, marketing: true, preferences: true }, close);
        else if (a === 'decline') setConsent(api, { analytics: false, marketing: false, preferences: false }, close);
        else if (a === 'prefs') showPrefs();
        else if (a === 'save') {
          var get = function (k){ var s = root.querySelector('[data-toggle="' + k + '"]'); return s && s.getAttribute('aria-checked') === 'true'; };
          setConsent(api, { analytics: get('analytics'), marketing: get('marketing'), preferences: get('preferences') }, close);
        }
      };
    });
  }

  function start(){
    mount();
    var saved = loadChoice();
    if (!FORCE && saved) {
      // Returning visitor who already chose (THIS is the fix for the banner reappearing
      // on every page): re-assert their consent so Shopify's tracking matches this page,
      // then show nothing.
      withAPI(function (a){ api = a; setConsent(api, saved, function (){}); });
      hide(); resolveConsent();
      return;
    }
    withAPI(function (a){
      api = a;
      var must = false;
      try { must = a && typeof a.shouldShowBanner === 'function' ? a.shouldShowBanner() : false; } catch (e) {}
      if (FORCE || must) showBanner();   // first-time visitor in a consent region → ask once
      else { hide(); resolveConsent(); } // no consent UI needed → show nothing
    });
  }

  // Re-open hook for an optional "Cookie settings" link anywhere (e.g. the footer),
  // so consent can still be withdrawn/changed without a permanent on-screen pill.
  function openSettings(e){ if (e && e.preventDefault) e.preventDefault(); showBanner(); }
  window.ShamtamCookieSettings = openSettings;
  document.addEventListener('click', function (e){
    var t = e.target && e.target.closest && e.target.closest('[data-cookie-settings], a[href="#cookie-settings"], a[href$="#cookie-settings"]');
    if (t) openSettings(e);
  });
  // Localise any footer "Cookie settings" link from the same 21-lang strings.
  function labelSettingsLinks(){
    try { var els = document.querySelectorAll('[data-cookie-settings]'); for (var i = 0; i < els.length; i++) { if (T.reopen) els[i].textContent = T.reopen; } } catch (e) {}
  }

  loadI18n(function (){
    function go(){ labelSettingsLinks(); start(); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go);
    else go();
  });
})();
